export default __webpack_public_path__ + "static/media/big-cartel-logo.b61ee6e7.png";